import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AdminAuthService } from './admin-auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {
  constructor(private auth: AdminAuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.auth.getToken();
    const isApiRequest = req.url.indexOf(environment.apiBaseUrl) === 0;
    const isAdminApi = req.url.indexOf(`${environment.apiBaseUrl}/admin/`) === 0;

    const authReq =
      token && isApiRequest && isAdminApi
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;

    return next.handle(authReq).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 401 && isAdminApi) {
          this.auth.logout();
          this.router.navigate(['/admin/login']);
        }
        return throwError(err);
      })
    );
  }
}

